import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, BookOpen, Phone } from "lucide-react";
import { Logo } from "../Logo";

const LINKS = [
  { href: "#gallery", label: "Gallery" },
  { href: "#amenities", label: "Amenities" },
  { href: "#sleeping", label: "Sleeping" },
  { href: "#location", label: "Location" },
  { href: "#weddings", label: "Weddings" },
  { href: "#faq", label: "FAQ" },
];

export const SiteHeader = ({ property }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "bg-cream/90 backdrop-blur-md border-b border-charcoal/10 shadow-sm" : "bg-transparent"}`} data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-16 sm:h-20 flex items-center justify-between">
        <span className={scrolled ? "" : "[&_span]:!text-cream"}>
          <Logo dark={!scrolled} />
        </span>
        <nav className="hidden lg:flex items-center gap-7" aria-label="Site">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href}
              className={`text-sm font-semibold tracking-wide transition-colors ${scrolled ? "text-soft hover:text-charcoal" : "text-cream/85 hover:text-cream"}`}
              data-testid={`site-nav-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <a href={`tel:${property.phone_tel}`} className={`hidden md:inline-flex items-center gap-2 text-sm font-semibold px-2 ${scrolled ? "text-charcoal" : "text-cream"}`} data-testid="site-header-call">
            <Phone size={14} aria-hidden /> {property.phone_display}
          </a>
          <Link to="/login" className={`hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold rounded-full px-4 py-2.5 border transition-colors ${scrolled ? "border-charcoal/20 text-charcoal hover:border-copper" : "border-cream/40 text-cream hover:bg-cream/10"}`} data-testid="nav-guest-login-link">
            <BookOpen size={14} aria-hidden /> Guest Login
          </Link>
          <a href={`tel:${property.phone_tel}`}
            className="inline-flex items-center bg-copper text-cream text-sm font-semibold rounded-full px-5 py-2.5 hover:bg-copperdeep transition-colors"
            data-testid="nav-book-now-button">
            Call to Book
          </a>
          <button className={`lg:hidden p-2 ${scrolled ? "text-charcoal" : "text-cream"}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu" data-testid="mobile-menu-button">
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="lg:hidden bg-cream border-t border-charcoal/10 px-6 py-4 space-y-1 shadow-lg" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)} className="block py-2.5 font-semibold text-charcoal" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</a>
          ))}
          <Link to="/guide" onClick={() => setMenuOpen(false)} className="block py-2.5 font-semibold text-copperdeep" data-testid="mobile-nav-guide">Guest Guide</Link>
        </div>
      )}
    </header>
  );
};
